import { render, staticRenderFns } from "./Fields-Search-Match.vue?vue&type=template&id=6bf7aa50&lang=pug"
import script from "./Fields-Search-Match.vue?vue&type=script&lang=ts"
export * from "./Fields-Search-Match.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports